import React from 'react';
import withClickOutside from '../../../../hoc/withClickOutside';
import ConfirmPopup from '../../../components/ConfirmPopup/ConfirmPopup';
import PopupWrapper from '../../../components/Popup/PopupWrapper';
import PopupHeader from '../../../components/Popup/PopupHeader';
import PopupBody from '../../../components/Popup/PopupBody';
import PopupButtons from '../../../components/Popup/PopupButtons';
import PopupButton from '../../../components/Popup/PopupButton';
import PopupCancelButton from '../../../components/Popup/PopupCancelButton';
import TextFieldWithJsonWrapper from '../../../components/TextFieldWithJsonWrapper/TextFieldWithJsonWrapper';
import JsonPanelHeader from '../JsonPanel/JsonPanelHeader';
import JsonPanelBody from '../JsonPanel/JsonPanelBody';
import JsonPanel from '../JsonPanel/JsonPanel';
import { smartJSONParse } from '../../../../services/mini/isValidJSON';

class ExportImportTestCasesPanel extends React.Component {
    constructor(props, context) {
        super(props, context);

        const conversationsStr = JSON.stringify(this.props.conversations, false, 4);

        this.state = {
            conversations: conversationsStr,
            initialConversations: conversationsStr,
            error: null,
            conversationsValid: true,
            mode: 'screen1'
        };
    }

    onFocus = () => {
        this.setState({ focused: true });
    }

    onBlur = (e) => {
        this.validate(e.target.value);
        this.setState({ focused: false });
    }

    onChange = (conversations) => {
        this.setState({ conversations });
    }

    onValidate = (conversationsValid) => {
        this.setState({ conversationsValid });
    }

    handleClickOutside = () => {
        this.cancel();
    }

    cancel = () => {
        this.props.onClose();
    }

    apply = () => {
        const { conversationsValid } = this.state;
        if (!conversationsValid) {
            return;
        }
        this.setState({ mode: 'screen2' });
    }

    clear = () => {
        this.setState({ conversations: '', conversationsValid: true });
    }

    render() {
        const {
            conversations,
            initialConversations,
            mode
        } = this.state;
        const { project, importTestConversations } = this.props;
        const disableApplyBtn = conversations === initialConversations || !conversations;

        return (
            <div className={`export-import-test-cases-panel_container ${mode}`}>
                <div className={`export-import-test-cases-panel_container_form-holder`}>
                    <PopupWrapper className="export-import-test-cases-panel">
                        <PopupBody>
                            <JsonPanel>
                                <JsonPanelHeader
                                    title={
                                        <div>
                                            Import / Export: Test Cases RAW Data
                                            <div className="export-import-test-cases-panel_info">
                                            To export a test case to another project, copy the content below, go to the target project &gt; Test Mode &gt; Import/Export Test Cases and insert the copied code there. 
                                             </div>
                                        </div>
                                    }
                                    showBtns={true}
                                    onClear={this.clear}
                                    value={conversations}
                                />
                                <JsonPanelBody>
                                    <TextFieldWithJsonWrapper
                                        skipJsonPreparation={true}
                                        placeholder="Paste Test Cases RAW Data here..."
                                        value={conversations}
                                        onChange={this.onChange}
                                        onValidate={this.onValidate} />
                                </JsonPanelBody>
                                <PopupButtons>
                                    <PopupCancelButton label="Close" action={this.cancel} />
                                    <PopupButton
                                        label="Apply Changes"
                                        action={this.apply}
                                        className={`${disableApplyBtn && 'disabled'}`} />
                                </PopupButtons>
                            </JsonPanel>
                        </PopupBody>
                    </PopupWrapper>
                </div>
                <div className="export-import-test-cases-panel_container_form-separator" />
                <div className="export-import-test-cases-panel_container_form-holder">
                    {mode === 'screen2' &&
                        <ConfirmPopup
                            onClose={() => {
                                this.setState({ mode: 'screen1' });
                            }}
                            okBtnLabel="Apply"
                            okBtnCb={() => {
                                importTestConversations({
                                    project: project,
                                    conversations: smartJSONParse(conversations, true)
                                });
                                this.cancel();
                            }}
                            title="Apply Changes"
                            message={<div>All current test cases with the same names will be replaced.<br />
                            This action cannot be undone.</div>} />}
                </div>
            </div>
        );
    }
}

export default withClickOutside(ExportImportTestCasesPanel, 'export-import-test-cases-panel_container_form-holder');
